export default __webpack_public_path__ + "static/media/logo.c89c62cf.png";